<template>
    <v-app>
        <v-toolbar color="peterBlue" fixed app dark>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn flat @click="logout">Log Out</v-btn>
            </v-toolbar-items>
        </v-toolbar>

        <v-content>
            <v-container fluid full-height>
                <v-alert v-model="hasLicenseWarning" type="warning">{{ licenseWarningMessage }}</v-alert>
                <v-alert v-model="hasLicenseError" type="error">{{ licenseErrorMessage }}</v-alert>
                <router-view v-transition></router-view>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>

import { mapState } from 'vuex';

export default {
    name: 'mfa',
    methods: {
        logout() {
            this.$store
                .dispatch('users/LOGOUT')
                .then(() => {
                    this.$router.push({ name: 'Login' });
                })
                .catch((e) => {
                });
        },
    },
    computed: {
		...mapState('license', {
			hasLicenseError: 'hasError',
			hasLicenseWarning: 'hasWarning',
			licenseErrorMessage: 'error',
			licenseWarningMessage: 'warning',
			license: 'license',
		}),
    }
}
</script>


// WEBPACK FOOTER //
// src/layouts/mfa.vue